import { AxiosInstance, AxiosResponse } from 'axios';
import ITechStats from '@models/ITechStats';
import IRisk from '@models/IRisk';
import TechImpact from '@models/TechImpact';
import AxiosClientBuilder, { ApiName } from '../../AxiosClientBuilder';

export class StatsApi {
  private static ROOT = '/stats';

  private static client: AxiosInstance = new AxiosClientBuilder()
    .setApiName(ApiName.Technologies)
    .setPrivate(true)
    .build();

  static getRandomTechnology(): Promise<AxiosResponse<ITechStats>> {
    return this.client.get<ITechStats>(`${this.ROOT}/random`);
  }

  static getStats(keyword: string): Promise<AxiosResponse<ITechStats>> {
    return this.client.get<ITechStats>(`${this.ROOT}/${keyword}`);
  }

  static getRiskyTechAffiliations(
    tech: string,
  ): Promise<AxiosResponse<IRisk[]>> {
    return this.client.get<IRisk[]>(`${this.ROOT}/riskyTechAffiliations`, {
      params: { tech },
    });
  }

  static getTechImpacts(tech: string): Promise<AxiosResponse<TechImpact[]>> {
    return this.client.get<TechImpact[]>(`${this.ROOT}/techImpacts`, {
      params: { tech },
    });
  }

  static getTechAffiliations(
    affiliation: string,
    keyword: string,
  ): Promise<AxiosResponse<string[]>> {
    return this.client.get<string[]>(`${this.ROOT}/techAffiliations`, {
      params: { affiliation, keyword },
    });
  }
}
